import React from "react";
import {GridContainerFlex} from "../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../GridFlex/GridItemFlex/GridItemFlex.jsx";

export const HeaderLayout = (props) => {

    return (
        <GridContainerFlex>
            <GridItemFlex xs={12}>
                {props.children}
            </GridItemFlex>
        </GridContainerFlex>
    )
}